import Vue from 'vue'
import gql from 'graphql-tag'

import createGraphQLClient from '@utils/graphql'

let graphqlClient = null

export const state = {
  objects: {},
  currentUser: {}
}

export const getters = {}

export const mutations = {
  SET_USERS(state, objects) {
    let updatedObjects = {}
    for (let key in objects) {
      if (!objects[key].deleted_at) {
        // Remove the '__typename' field that gets added by GraphQL
        delete objects[key].__typename
        // Stage the update so we can just do one Vue.set
        updatedObjects[objects[key].id] = objects[key]
      } else if (state.objects.hasOwnProperty(objects[key].id)) {
        // Immediately delete the object
        Vue.delete(state.objects, objects[key].id)
      }
    }
    state.objects = {
      ...updatedObjects,
    }
  },
  SET_USER(state, objects) {
    state.currentUser = objects
  }
}

export const actions = {
  init({ commit, rootState }) {
    // Initialise the GraphQL client
    graphqlClient = createGraphQLClient(rootState)
  },

  async getUsers({ commit }) {
    try {
      const response = await
          graphqlClient.query({
              query: gql`
              query getUsers{
                users {
                  id
                  username
                  name
                  email
                  role{
                    id
                    name
                  }
                  mobile
                  created_at
                  deleted_at
                  updated_at
                }
              }
            `,
          })
        commit('SET_USERS', response.data.users)
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async userById({ commit }, { id } = {}) {
    try {
      const response = await graphqlClient.query({
        query: gql`
          query GetUserById($did: ID!){
            userById(id: $did) {
              id
              username
              name
              mobile
              email
              role{
                id
                name
              }
              created_at
              deleted_at
              updated_at
            }
          }
        `,
        variables:{ did: id }
      })
      commit('SET_USER', response.data.userById)
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async createUser({ commit, dispatch }, {name, username, mobile, email, password, role} = {}) {
    try {
      // let that = this
      // console.log(role)
      await graphqlClient.mutate({
        mutation: gql`
        mutation CreateUser($uname: String! $pwrd: String! $nme: String! $mble: String! $eml: String!, $role: String!)  {
          createUser(user:{username:$uname password:$pwrd name:$nme mobile:$mble email:$eml role:$role}) {
            id
            username
          }
        }
        `,
        variables: { uname: username, pwrd: password, nme: name, mble: mobile, eml: email, role: role },
      })
      dispatch('getUsers')
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  // UPDATE DRIVER MUTATION
  // mutation {
  //   updateDriver(id: 1 driver:{name: "Charlie"}) {
  //     id
  //     name
  //   }
  // }

  async updateUser({ commit }, {id, name, username, mobile, email, password} = {}) {
    try {
      // let that = this
      const response = await graphqlClient.mutate({
        mutation: gql`
        mutation UpdateUser($did:Int! $uname: String $pwrd: String $nme: String $mble: String $eml: String)  {
          updateUser(id: $did user:{username:$uname password:$pwrd name:$nme mobile:$mble email:$eml}) {
            id
          }
        }
        `,
        variables: { did: id, uname: username, pwrd: password, nme: name, mble: mobile, eml: email },
      })
        commit('SET_USERS', response.data.updateUser)
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },
    async deleteUser({ commit }, {id} = {}) {
        try {
            // let that = this
            const response = await graphqlClient.mutate({
                mutation: gql`
                mutation DeleteUser($did:Int!)  {
                  deleteUser(id: $did) {
                    id
                  }
                }
                `,
                variables: { did: id},
            })
            commit('SET_USERS', response.data.deleteUser)

        } catch (ex) {
            console.error(ex)
            throw ex
        }
    }
}
